module.exports = __webpack_public_path__ + "img/49200B_C6926C_9C642B_A45C26-256px.f044b2fc.png";